import register from 'ShopUiBundle/modules/app/registry';
import './usercentrics-view-loader.scss';

// tslint:disable-next-line
register('usercentrics-view-loader', () => import(/* webpackMode: "lazy" */'./usercentrics-view-loader'));
